import PropTypes                  from 'prop-types';
import React                      from 'react';
import styles                     from './DetailsForm.less';
import { PropertiesUtils as OPU } from '@wix/wixrest-utils';
import Properties                 from '@wix/wixrest-properties';
import Input                      from '../../../../shared/components/Input/Input';

const MAXLENGTH = 50;

export default class CustomFields extends React.Component {
    static propTypes = {
        organization : PropTypes.object.isRequired,
        reservation  : PropTypes.object.isRequired,
        onChange     : PropTypes.func,
        onFocus      : PropTypes.func,
        onSubmit     : PropTypes.func,
        errors       : PropTypes.object,
        i18n         : PropTypes.object.isRequired,
    };

    static defaultProps = {
        errors : {}
    };

    constructor(props) {
        super(props);
    }

    _onChange = (label, value, index) => {
        this.props.onChange(index, {
            label,
            value
        });
    }

    _renderField = (field, index) => {
        const {
            reservation,
            onFocus,
            onSubmit,
            errors,
            i18n
        } = this.props;

        const value = _.get(reservation, `customFields.${index}.value`);
        const error =
            errors.customFields
            && (errors.customFields.includes(index) || null) // must be string or null, not boolean
            && i18n.get('reservationsettings_modal_tooltip', 'This field is required');

        return (
            <div
                className  = {styles.detailSection}
                key        = {index}
                data-hook  = "custom-field"
            >
                <Input
                    placeholder      = {field.label}
                    value            = {value}
                    error            = {error}
                    errorTooltip     = {true}
                    dataHook         = "custom-field-input"
                    onChange         = {value => this._onChange(field.label, value, index)}
                    onFocus          = {onFocus}
                    onEnter          = {onSubmit}
                    placeholderClass = {styles.placeholder}
                    containerClass   = {styles.inputContainer}
                    focusClass       = {styles.focus}
                    inputClass       = {styles.input}
                    maxLength        = {MAXLENGTH}
                />
            </div>
        );
    }

    render() {
        const { organization } = this.props;
        const customFields = OPU.get(organization.reservations, Properties.Reservations.CUSTOMFIELDS, 'com.wix.restaurants');

        if (!customFields) return null;

        return (
            <div>
                {customFields.map(this._renderField)}
            </div>
        );
    }
};
